import i18n from '@/i18n'; // 

export default {
  listHeaders() {
    return [
      { text: i18n.t('code'), value: 'id' },
      { text: i18n.t('kyeEmployeeName'), value: 'calisanAdSoyad' },
      { text: i18n.t('identityNumber'), value: 'kimlikNo' },
      { text: i18n.t('createDate'), value: 'olusturmaTarihi' },
    ];
  },
};
